import SmotriButton from "@components/SmotriButton";
import { Airplay, Megaphone, MonitorSpeaker, Trophy } from "lucide-react";
import bannerPhoto from "@images/banner-photo-1.png";
import titlePattern from "@svg/pattern.png";

const iconClass = "h-[38px] w-[38px] text-[#495FDE]";

const features = [
  {
    title: "Новые релизы каждую неделю",
    icon: Airplay,
  },
  {
    title: "Без рекламы и скрытых платежей",
    icon: Megaphone,
  },
  {
    title: "Доступно на любых устройствах",
    icon: MonitorSpeaker,
  },
  {
    title: "Самые интересные премьеры",
    icon: Trophy,
  },
];

export default function PremieresBanner() {
  return (
    <section className="w-full bg-black px-4 py-6 sm:px-8 sm:py-10 xl:px-20 xl:pb-14">
      <div className="relative isolate mx-auto flex min-h-[640px] w-full max-w-[1760px] flex-col justify-end gap-[39px] overflow-hidden rounded-[20px] bg-[#050505] px-6 py-8 md:h-[600px] md:min-h-0 md:justify-center md:rounded-[24px] md:px-12 xl:px-20 xl:pb-20 xl:pt-16">
        <div className="absolute right-0 top-0 -z-30 h-[48%] w-full overflow-hidden md:h-full md:w-[62%] md:max-w-[1050px]">
          <img
            className="h-full w-full object-cover object-right-top md:object-right"
            src={bannerPhoto}
            alt=""
            aria-hidden="true"
          />
          <div
            className="pointer-events-none absolute inset-0 bg-[linear-gradient(180deg,rgba(5,5,5,0.62)_0%,rgba(5,5,5,0)_28%,rgba(5,5,5,0)_62%,rgba(5,5,5,0.7)_100%),linear-gradient(270deg,rgba(5,5,5,0.72)_0%,rgba(5,5,5,0)_30%)]"
            aria-hidden="true"
          />
        </div>

        <div className="flex w-full max-w-[824px] flex-col items-start gap-10">
          <div className="jost-m flex flex-col uppercase leading-[0.92] tracking-[-0.01em] text-white">
            <span
              className="bg-cover bg-center bg-clip-text text-[52px] text-transparent sm:text-[64px] md:text-[76px]"
              style={{ backgroundImage: `url(${titlePattern})` }}
            >
              smotri
            </span>
            <span className="text-[38px] sm:text-[52px] md:text-[76px]">
              мировые премьеры
            </span>
          </div>

          <div className="grid w-full max-w-[824px] grid-cols-1 gap-5 md:grid-cols-2 md:gap-x-9 md:gap-y-7 xl:grid-cols-[372px_372px] xl:gap-x-20 xl:gap-y-8">
            {features.map(({ title, icon: Icon }) => (
              <div
                className="flex min-h-[72px] w-full items-center gap-[18px] md:min-h-[84px] md:gap-7 xl:w-[372px]"
                key={title}
              >
                <div className="flex h-[72px] w-[72px] shrink-0 items-center justify-center rounded-xl bg-[#111111] p-[18px] md:h-[84px] md:w-[84px] md:p-[22px]">
                  <Icon className={iconClass} strokeWidth={1.5} aria-hidden="true" />
                </div>
                <div className="inter-r flex min-h-0 w-auto items-center text-xl leading-[140%] tracking-[-0.01em] text-white md:min-h-[68px] md:w-[260px] md:text-2xl">
                  {title}
                </div>
              </div>
            ))}
          </div>

          <div className="flex h-auto w-full flex-wrap items-center gap-6 md:h-14 md:w-[362px]">
            <SmotriButton className="h-auto py-[18px]">
              Смотреть с подпиской
            </SmotriButton>
            <div className="inter-m flex h-6 w-[125px] items-center whitespace-nowrap text-xl leading-[120%] tracking-[-0.01em] text-[#4B4B4B]">
              от 166 ₽/мес
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
